import styled, { css } from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import InputSimple, { nameDecorator, phoneDecorator } from '@r1-frontend/ui-react/components/inputSimple';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

const InputPhoneDecorator = phoneDecorator(InputSimple);
const InputNameDecorator = nameDecorator(InputSimple);

const CommonInputCss = css`
    width: 244px;
    margin: 0;

    input:-webkit-autofill,
    input:-webkit-autofill:hover, 
    input:-webkit-autofill:focus, 
    input:-webkit-autofill:active  {
        -webkit-text-fill-color: white;
        box-shadow: 0 0 0 100px transparent inset;
        transition: background-color 2000s ease-in-out 0s;
        background: linear-gradient(top,
        rgba(255,255,255,0) 0%,rgba(0,174,255,.04) 50%, rgba(255,255,255,0) 51%, rgba(0,174,255,.03) 100%);
    }

    input {
        background: rgba(255, 255, 255, .05);
        border-radius: 5px;
        height: 55px;
        color: ${COLORS.white};
    }
`;

export const FormContainer = styled.div`
    position: relative;
    width: 592px;
    height: fit-content;
    min-height: 298px;
    flex-direction: column;
    gap: 15px;
    background-color: rgba(255, 255, 255, .05);
    border-radius: ${BorderRadius.OuterBlockRadius};
    padding: 32px 36px 20px 36px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: auto;
        max-width: 592px;
    }
`;

export const TitleWrap = styled.div`
    height: fit-content;
    gap: 3px;
`;

export const SubText = styled.span`
    max-width: 85%;
    ${FONTS.XS};
    color: ${COLORS.GRAY_S};
`;

export const Title = styled.span`
     ${FONTS.H4};
     color: ${COLORS.white};
`;

export const InputsWrap = styled.div`
    height: fit-content;
    width: 100%;
    justify-content: space-between;
    gap: 20px;

    @media (max-width: ${wideBreakpoints.sMobile}) {
        width: 234px;
    }
`;

export const LegalWrap = styled.div`
    gap: 10px;
    color: ${COLORS.GRAY_S};
`;

export const ButtonContainer = styled.div`
    width: 100%;
`;

export const ButtonWrap = styled(BaseButton)<{ disabled: boolean }>`
    width: 264px;
    cursor: ${(p) => p.disabled ? 'default' : 'pointer' };

    @media (max-width: ${wideBreakpoints.sMobile}) {
        width: 234px;
    }
`;

export const InputPhone = styled(InputPhoneDecorator)`
    ${CommonInputCss};
`;

export const InputName = styled(InputNameDecorator)`
    ${CommonInputCss};
`;

export const AgreeTextWrap = styled.div`
    ${FONTS.XS};
    color: ${COLORS.GRAY_S};

    @media (max-width: 450px) {
        width: 200px;
    }
`;

export const AgreeTextUnderLine = styled.a`
    text-decoration: underline;
    color: ${COLORS.GRAY_S};
`;
